import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  tooltipContainer: {
    backgroundColor: theme.vars.palette.background.elevation2,
    padding: theme.spacing(2),
    border: `1px solid ${theme.vars.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    boxShadow: '0 0 8px rgba(0, 0, 0, 0.8)'
  },
  tooltipDescription: {
    display: 'inline-block',
    fontSize: '0.75rem'
  },
  tooltipLabel: {
    display: 'inline-block',
    fontSize: '0.75rem',
    fontWeight: 'bold'
  }
}));

export default useStyles;
